import React, { Component } from "react";
import uploadIcon from '../../../assets/images/Icon feather-upload-cloud.png'
import './style.scss';
import { connect } from "react-redux";
import { newSOHTool } from "../../../store/actions/file-conversion/soh-tool";
import { Buffer } from 'buffer';
import Loader from '../../../components/loader'
import FileUpload from "../../../components/file-upload";

class SOHToolView extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    src: null,
    file: null,
    fileConvertError: false,
    loading: false
  };

  onSelectFile = (e, drop) => {
    let file = drop ? e.dataTransfer.files[0] : e.target.files[0];
    if (!file) return;
    let reader = new FileReader();
    this.setState({
      file: file,
      fileConvertError: null,
      SOHFileName: file.name,
    });
    reader.readAsDataURL(file);
    reader.onload = (res) =>
      this.setState({
        src: res.target.result,
      });
  };

  uploadFile = async (fileInput) => {
    this.setState({ loading: true })
    const i = this.state.src.indexOf("base64,");
    const buffer = Buffer.from(this.state.src.slice(i + 7), "base64");
    const file = new File([buffer], this.state.SOHFileName, {
      type: "text/plain",
    });

    const fd = new FormData();
    fd.append("file", file);
    fd.append("filename", file.name);
    fd.append("companyId", this.props.UserReducer.companyId);
    await this.props.newSOHTool(fd);
    let SOHTool = this.props.SOHToolReducer;
    this.setState({ loading: false });
    if (this.props.setErrorReducer?.length || this.props.setErrorReducer?.error) return;
    const url = window.URL.createObjectURL(
      new Blob([SOHTool], { type: "application/*" })
    );
    const fileName = this.state.SOHFileName;
    const _fileName = fileName.split(".")[0];
    const currentDate = new Date().toLocaleString().replace(/[\/,:\s]/g, "_").replace(/(_(A|P)M)/, "");
    const currentFileName = `SOH_${currentDate}_${_fileName}.csv`;
    fileInput.current.value = null;
    this.setState({
      src: null,
      SOHFileName: "",
    });
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${currentFileName}`
    );
    document.body.appendChild(link);
    link.click();

  };

  render() {
    return (
      <FileUpload
        HtmlFor="upld_soh"
        CAPTION="SPREAD OF HOURS TOOL"
        FileError={this.state.fileConvertError}
        Accept=".xls, .xlsx, .csv,.txt"
        Color="#83eb47"
        OnSelectFile={this.onSelectFile}
        UploadFile={this.uploadFile}
      />
    );
  }
}
const mapStateToProps = ({ UserReducer, SOHToolReducer, setErrorReducer }) => ({ UserReducer, SOHToolReducer, setErrorReducer });

export default connect(mapStateToProps, { newSOHTool })(SOHToolView);
